import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Check, Clear } from "@material-ui/icons";
import { Events, Workouts } from "app-interfaces";
import React from "react";
import { Route, Switch } from "react-router-dom";

import trashIcon from "../../assets/delete.png";
import Icons from "../Utilities/Icons";

const useStyles = makeStyles((_theme) => ({
  mainContainer: {
    position: "relative",
  },
  dltIcon: {
    width: 20,
    cursor: "pointer",
    position: "absolute",
    top: 15,
    right: 0,
  },
  paper: {
    borderLeft: "3px solid #F8E71C",
    marginBottom: 25,
    "& .MuiGrid-grid-xs-10": {
      "& .MuiContainer-root:last-child": {
        "& .MuiTypography-body2": { borderBottom: "none", paddingBottom: 0 },
      },
    },
    "& .set-status": {
      display: "block",
      height: 37,
      width: 37,
      "& svg": {
        padding: 5,
        height: "100%",
        width: "100%",
        borderRadius: "100%",
        "&.clear": {
          border: "2px solid #dc3545",
          fill: "#dc3545",
        },
        "&.check": {
          border: "2px solid #7ed321",
          fill: "#7ed321",
        },
      },
    },
    "& .set-index": {
      display: "block",
      color: "var(--text-primary)",
      border: "2px solid var(--text-primary)",
      borderRadius: "100%",
      padding: "6px 0",
      height: 37,
      width: 37,
      textAlign: "center",
      fontSize: 16,
      fontWeight: 500,
    },
    "& .completeIcon": {
      height: 37,
      width: 37,
    },
  },
}));

type ExerciseSetProps = {
  superset: Workouts.IExerciseSuperSet;
  supersetIndex: number;
  exerciseList: JSX.Element[];
  toggled?: boolean;
  session?: Events.ISession;
  handleSuperSet?: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
};

export default function ExerciseSetsList({
  superset,
  supersetIndex,
  exerciseList,
  toggled,
  session,
  handleSuperSet,
}: ExerciseSetProps) {
  const classes = useStyles();

  return (
    <li
      id={superset.id}
      // onClick={!toggled ? handleSuperSet : undefined}
      onMouseEnter={(e) => {
        if (!toggled && handleSuperSet) {
          e.currentTarget.style.backgroundImage = `url(${Icons.ic_del})`;
          e.currentTarget.style.backgroundRepeat = "no-repeat";
          e.currentTarget.style.backgroundPositionX = "80px";
          e.currentTarget.style.backgroundPositionY = "25px";
        }
      }}
      onMouseLeave={(e) => {
        if (!toggled && handleSuperSet) e.currentTarget.style.backgroundImage = "none";
      }}
    >
      <Switch>
        <Route path="/workouts">
          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              <Grid
                item
                xs={1}
                style={{
                  padding: "15px 25px",
                }}
              >
                <span className="set-index">{supersetIndex + 1}</span>
              </Grid>
              <Grid item xs={8} md={10} className={classes.mainContainer}>
                {exerciseList}
                {!toggled && !!handleSuperSet && (
                  <span id={superset.id} onClick={handleSuperSet}>
                    <img alt="trash icon" src={trashIcon} className={classes.dltIcon} />
                    {/*<Delete className={classes.dltIcon} />*/}
                  </span>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Route>
        <Route
          path={["/", "/schedules", "/clients/sessions"]}
          render={() => {
            const image = superset.exercises.find(
              (exercise) =>
                exercise.result_vals.length === 0 ||
                exercise.result_vals.length < exercise.score_count ||
                exercise.result_vals[0] === null ||
                !exercise.result_vals[0] ||
                exercise.result_vals.find((el) => {
                  return el === null || el === 0;
                })
            ) ? (
              session?.state === "NONE" ? (
                <span className="set-index">{supersetIndex + 1}</span>
              ) : session?.state ? (
                <Clear className="clear" />
              ) : (
                <span className="set-index">{supersetIndex + 1}</span>
              )
            ) : session?.state === "NONE" || session?.state === "COMPLETED" ? (
              <Check className="check" />
            ) : (
              <span className="set-index">{supersetIndex + 1}</span>
            );
            return session && session.state !== "NONE" ? (
              <Paper className={classes.paper}>
                <Grid container spacing={3}>
                  <Grid item xs={1} style={{ padding: "15px 25px" }}>
                    <span className="set-status">{image}</span>
                  </Grid>
                  <Grid item xs={8} md={10}>
                    {exerciseList}
                  </Grid>
                </Grid>
              </Paper>
            ) : (
              <Paper className={classes.paper}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    xs={1}
                    style={{
                      padding: "15px 25px",
                    }}
                  >
                    {/* <span className='set-index'>{supersetIndex + 1}</span> */}
                    <span className="set-status">{image}</span>
                  </Grid>
                  <Grid item xs={8} md={10} className={classes.mainContainer}>
                    {exerciseList}
                    {
                      !toggled && !!handleSuperSet && (
                        <span id={superset.id} onClick={!toggled ? handleSuperSet : undefined}>
                          <img
                            alt=""
                            src={process.env.PUBLIC_URL + "/dlt.PNG"}
                            className={classes.dltIcon}
                          />
                        </span>
                      )
                      // <DeleteIcon className={classes.dltIcon} />
                    }
                  </Grid>
                </Grid>
              </Paper>
            );
          }}
        />
      </Switch>
    </li>
  );
}
